class DESAlgorithm {
  constructor(setParams) {
    this.setParams = setParams;
  }

  getInputs(params) {
    return <div>No inputs required for DES</div>;
  }
}

export default DESAlgorithm;